
import React from 'react';
import {DateTime} from "luxon";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import { get } from 'lodash';
import Input from "../../theme/forms/Input";
import getSubdomainString from '../../../utils/getSubdomainString';
import formatters from '../../../utils/forms/formatters';

const getImprovementName = (id, improvements = []) => {
    if (!improvements || improvements.length == 0) return "";
    const improvement = improvements.find((i) => i.id == id);
    return improvement ? improvement.name : "";
};



function ProjectCard({ project= {} }) {

    let system_improvements = useSelector(state => state.indicativeOptionData.improvements)

    if (!project) return <div />;
    let { created, data, estimate_groups, user } = project;
    // if (!data) data = project;
    const { address, project_name, improvements } = data || {};

    if (!address) return <div />;
    const modifiedFormattedCreateDate = DateTime.fromJSDate(new Date(created)).toFormat(
        "D"
    );

    let project_completed = estimate_groups.length > 0 || project.application_id;

    let from_subdomain = !!project.subdomain && !['www', 'app', '', null, undefined, 'cleanfi', 'narwhal'].includes(project.subdomain) && project.subdomain !== getSubdomainString();

    return (
        <div
            key={project.id + "key-projects"}
            className="box box-my-project is-flex is-flex-direction-column flex-start"
        >
            <div className="is-flex is-justify-content-space-between">

                <div>
                    <h3>
                        <b>{project_name}</b>
                    </h3>
                    <p>{address && address.formatted_address}</p>
                    <p className="user-title">
                        <b>
                            Created by: {project.user_first_name} {project.user_last_name}
                        </b> - <a href={`mail    to:${project.user_email}`}>{project.user_email}</a>
                    </p>
                    {from_subdomain &&
                        <p className="user-title has-text-primary mt-3">
                             Created on: <b>{project.subdomain}</b>
                        </p>
                    }
                </div>

                <div>
                    <div>{modifiedFormattedCreateDate}</div>
                    {!!project.application_payment_amount &&
                        <div className="has-text-success has-text-weight-semibold">
                            PAID: ${project.application_payment_amount} on {project.payment_date}
                            </div>
                    }
                    {from_subdomain && <div className='has-text-weight-semibold'>{project.subdomain}</div>}
                </div>

            </div>
            <hr />
            <div className="is-flex is-justify-content-space-between">
                <div className="">
                    {improvements &&
                        improvements.length > 0 &&
                        improvements.map((impr) => (
                            <h6 className="title is-6 mb-0 mt-2  improvements-items user-title">
                                <span>{getImprovementName(impr.id, system_improvements)}:</span>
                                <span>{impr.value ? ` ${formatters.USDCurrency.formatter(impr.value)}` : ` -`}</span>
                            </h6>
                        ))}
                </div>
                <div className="buttons">
                    {!project_completed &&

                        <button
                            onClick={() => null}
                            className="button is-danger m-0 mr-3 mb-2 disabled"
                        >
                            Project Not Yet Complete
                        </button>
                    }
                    {project_completed &&
                        <>
                            {!!project.application_id &&
                                <Link to={`/application/${project.application_id}`} target="_blank">
                                    <button
                                        className="button is-primary m-0 mr-3 mb-2"
                                    >
                                        View Application
                                    </button>
                                </Link>
                            }
                            <Link to={`/project-estimate/${project.id}`} target="_blank">
                                <button
                                    className="button is-link m-0 mr-3 mb-2"
                                >
                                    Get Today's Estimates
                                </button>
                            </Link>
                            <Input
                                inputClasses="mb-2"
                                type="select"
                                placeholder="View Past Estimate"
                                options={estimate_groups.map(d => (
                                    {
                                        value: d.id,
                                        display: DateTime.fromISO(d.created).toFormat("ff")
                                    }
                                ))
                                }
                                onChange={(id) => {
                                    window.open(`/share-estimate/?g=${id}`, '_blank')
                                }}
                            />
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;